// extracted by mini-css-extract-plugin
module.exports = {"error":"AllowanceEditingForm__error--OQneZ","section":"AllowanceEditingForm__section--34sJS Form__boxMain--FpqUy"};